import { Component } from 'react'
import readOnlyForm from '../../services/ReadOnlyForm';
import identity from '../../services/Identity';

class ParentEditorComponent extends Component {

    _createdMode = true;
    _divName = null;
    _service = null;
    _dataObject = null;
    _size = {};

    constructor(props, divName, service, dataObject) {
        super(props);
        this._divName = divName;
        this._service = service;
        this._dataObject = dataObject;
    }

    updateDimensions = () => {
        this._size["width"] = window.innerWidth;
        this._size["height"] = window.innerHeight;
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentDidUpdate() {
        if (this.props.popin) {
            readOnlyForm(false, this._divName);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    loadData(numero) {
        var data;
        var currentIdentity = numero;
        if (currentIdentity === null) {
            currentIdentity = identity();
        }

        if (currentIdentity != null) {
            this._createdMode = false;
        }
        if (this._createdMode) {
            data = new this._dataObject();
        } else {
            var service = new this._service();
            data = service.getByNumero(currentIdentity);
            if (data === null) { //l'id en param n'existe pas 
                this.createdMode = true;
                data = new this._dataObject();
            } 
        }
        return data;
    }

    get createdMode() {
        return this._createdMode;
    }

    set createdMode(newCreatedMode) {
        this._createdMode = newCreatedMode;
    }

    get size() {
        return this._size;
    }
}

export default ParentEditorComponent


// WEBPACK FOOTER //
// ./src/components/custom/ParentEditorComponent.js